import { NodeResult } from "../models/net/result/node-result";

export class NodeFactory {

    private constructor() { }

    public static getNodeByRoute = (route: string, nodesPool: NodeResult[] | null): NodeResult | null => {

        let result: NodeResult | null = null;

        if (nodesPool) {

            for (let i = 0; i < nodesPool.length; i++) {

                let node: NodeResult = nodesPool[i];

                if (node.Route == route) {

                    result = node;

                    break;

                } else {

                    if (node.Nodes.length > 0) {

                        result = this.getNodeByRoute(route, node.Nodes);

                        if (result != null) {

                            break;
                        }
                    }
                }
            }

            if (result == null) {

                // try to find the node by id if applicable
                const lastSlashIndex: number = route.lastIndexOf("/");

                if (lastSlashIndex !== -1) {

                    const numericSuffix: string = route.slice(route.lastIndexOf("/") + 1);
                    const nodeId: number = parseInt(numericSuffix, 10);

                    if (nodeId != null && !Number.isNaN(nodeId)) {

                        result = this.getNodeById(nodeId, nodesPool);
                    }
                }
            }
        }

        return result;
    }

    public static getRootNode = (nodesPool: NodeResult[] | null): NodeResult | null => {

        let result: NodeResult | null = null;

        if (nodesPool) {

            const root = nodesPool.find(node => node.ParentNodeId === null || node.ParentNodeId === undefined);

            if (root) {

                result = root;
            }
        }

        return result;
    }

    public static getNodeById = (nodeId: number, nodesPool: NodeResult[]): NodeResult => {

        const result = this.getNodeByIdRecursive(nodeId, nodesPool);

        return result;
    }

    public static getNodeByIdRecursive = (nodeId: number, nodesPool: NodeResult[]): NodeResult => {

        let result: NodeResult = new NodeResult();

        for (let i = 0; i < nodesPool.length; i++) {

            let node: NodeResult = nodesPool[i];

            if (node.NodeId == nodeId) {

                result = node;

                break;

            } else {

                if (node.Nodes.length > 0) {

                    result = this.getNodeByIdRecursive(nodeId, node.Nodes);

                    if (result.NodeId > 0) {

                        break;
                    }
                }
            }
        }

        return result;
    }
}
